<template lang="pug">
v-card(class="ma-2")
    v-card-title {{ title }}
    v-card-text {{ description }}
</template>

<script>
export default {
    props:["waypoint"],
    computed: {
        description() {
            switch(this.waypoint[0]) {
                case "Address":
                    return this.waypoint[1].a;
                case "Station":
                    return this.waypoint[1].Title;
            }
            return "";
        },
        title() {
                   switch(this.waypoint[0]) {
                case "Address":
                    return "Stopped At:";
                case "Station":
                    return "Charged At:";
            }
            return "";     
        }
    }
}
</script>